export const vapidKey = "BDsSOiumRzhWswXwgigPw9DTryPnRXYC6zHaLnEo70DSeGuY-s8mR2CqELvbr-zgCHIxNo2tnNvJU0CV5l3wQgU";


